<div class="m-4 px-6 pb-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 bg-white flex flex-col gap-4">
      <div
        class="px-4 py-2 text-general-title text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      >
        {{ 'general-pages.administrative.contactTitle' | translate }}
      </div>
      <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <app-input-general
          [formControlGeneral]="Customer.get('CONTACTO_NOMBRE')"
          [label]="'general-pages.administrative.customer.name' | translate"
          [placeholder]="'general-pages.administrative.customer.name' | translate"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Customer.get('CONTACTO_PATERNO')"
          [label]="'general-pages.administrative.customer.lastName' | translate"
          [placeholder]="'general-pages.administrative.customer.lastName' | translate"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Customer.get('CONTACTO_MATERNO')"
          [label]="'general-pages.administrative.customer.motherLastName' | translate"
          [placeholder]="'general-pages.administrative.customer.motherLastName' | translate"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Customer.get('TEL')"
          [label]="'general-pages.administrative.customer.phone' | translate"
          [placeholder]="'general-pages.administrative.customer.phone' | translate"
          [mask]="'(000) 000-0000'"
        ></app-input-general>

        <div class="w-full col-span-full"></div>
        <app-input-general
          [formControlGeneral]="Customer.get('CONTACTO_EMAIL')"
          [label]="'general-pages.administrative.customer.email' | translate"
          [placeholder]="'general-pages.administrative.customer.email' | translate"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Customer.get('EMAIL_USUARIO_APP')"
          [label]="'general-pages.administrative.customer.app-email' | translate"
          [placeholder]="'general-pages.administrative.customer.app-email' | translate"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Customer.get('CUENTA')"
          [label]="'general-pages.administrative.customer.account' | translate"
          [placeholder]="'general-pages.administrative.customer.account' | translate"
        ></app-input-general>

        <div class="h-18.25 flex items-center pb-5.5">
          <mat-checkbox [formControl]="$any(Customer.get('IS_FACTURAR'))">{{
            'general-pages.administrative.customer.bill' | translate
          }}</mat-checkbox>
        </div>
      </div>
    </div>

    <div class="lg:px-8 px-0 pb-4 bg-white flex flex-col gap-4">
      <div
        class="px-4 py-2 text-general-subtitle text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      >
        {{ 'general-pages.administrative.contractTitle' | translate }}
      </div>
      <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <div class="h-18.25 flex items-center pb-5.5 col-span-2">
          <mat-checkbox [formControl]="$any(Contract.get('IS_admon'))">Topar Renta</mat-checkbox>
        </div>

        <app-input-general
          [formControlGeneral]="Contract.get('admon')"
          class="col-span-2"
          [label]="'Monto Renta'"
          [placeholder]="'Monto Renta'"
        ></app-input-general>

        <div class="h-18.25 flex items-center pb-5.5 col-span-2">
          <mat-checkbox [formControl]="$any(Contract.get('IS_CORTE_AUT'))"
            >Corte de Motor Aut.</mat-checkbox
          >
        </div>

        <app-input-general
          [formControlGeneral]="Contract.get('DIAS_CORTE_AUT')"
          class="col-span-2"
          [label]="'Dias corte motor aut.'"
          [placeholder]="'Dias corte motor aut.'"
        ></app-input-general>

        <div class="h-18.25 flex items-center pb-5.5 col-span-4">
          <mat-checkbox [formControl]="$any(Contract.get('IS_TIMBRAR'))"
            >Retener Timbre</mat-checkbox
          >
        </div>
        <div class="h-18.25 flex items-center pb-5.5 col-span-4">
          <mat-checkbox [formControl]="$any(Contract.get('IS_MAIL_PAGOS'))"
            >Enviar Notificación Próximo Vencimiento</mat-checkbox
          >
        </div>
        <div class="h-18.25 flex items-center pb-5.5 col-span-4">
          <mat-checkbox [formControl]="$any(Contract.get('IS_MAIL_PAGOS_ATRASO'))"
            >Enviar Notificación de Retraso de Pagos</mat-checkbox
          >
        </div>
        <div class="h-18.25 flex items-center pb-5.5 col-span-4">
          <mat-checkbox [formControl]="$any(Contract.get('IS_KM_ILIMITED'))"
            >Kilometraje Ilimitado
          </mat-checkbox>
        </div>
        <div class="h-18.25 flex items-center pb-5.5 col-span-2">
          <mat-checkbox [formControl]="$any(Contract.get('IS_GENERA_MORA'))"
            >Generar Mora</mat-checkbox
          >
        </div>
        <div class="h-18.25 flex items-center pb-5.5 col-span-4">
          <mat-checkbox [formControl]="$any(Contract.get('IS_KM_ILIMITED'))"
            >Kilometraje limitado</mat-checkbox
          >
        </div>

        <app-input-general-calendar
          class="col-span-2"
          [label]="'Fecha inicio mora'"
          [placeholder]="'Fecha inicio mora'"
          [formControlGeneral]="Contract.get('FEC_INI_MORA')"
        ></app-input-general-calendar>

        <div class="h-18.25 flex items-center pb-5.5 col-span-2">
          <mat-checkbox [formControl]="$any(Contract.get('IS_GARANTIA_EXTENDIDA'))"
            >Garantia Extendida</mat-checkbox
          >
        </div>
        <app-input-general
          [formControlGeneral]="Contract.get('GARANTIA_EXTENDIDA')"
          class="col-span-2"
          [label]="'Garantia Extendida'"
          [placeholder]="'Garantia Extendida'"
        ></app-input-general>

        <div class="h-18.25 flex items-center pb-5.5 col-span-4">
          <mat-checkbox [formControl]="$any(Contract.get('IS_ENTREGADO'))"
            >¿Bien arrendado devuelto?</mat-checkbox
          >
        </div>

        <div class="h-18.25 flex items-center pb-5.5 col-span-2">
          <mat-checkbox [formControl]="$any(Contract.get('IS_GARANTIA'))">Aforar a</mat-checkbox>
        </div>
        <app-input-general-select
          [arrayData]="arizaData?.fondeadores"
          [inputSelect]="{ value: 'iD_FONDEADOR', description: 'desC_FONDEADOR' }"
          [formControlGeneral]="Contract.get('ID_FONDEADOR')"
          class="col-span-2"
          [label]="'Fondeador'"
          [placeholder]="'Fondeador'"
        ></app-input-general-select>

        <app-input-general-select
          [arrayData]="['TRANSFERENCIA ELECTRONICA', 'EFECTIVO', 'CHEQUE NOMINATIVO']"
          [formControlGeneral]="Contract.get('MetodoDePago')"
          class="col-span-4"
          [label]="'Método de pago'"
          [placeholder]="'Método de pago'"
        ></app-input-general-select>

        <app-input-general
          [formControlGeneral]="Contract.get('NUM_POLIZA')"
          class="col-span-2"
          [label]="'Poliza'"
          [placeholder]="'Poliza'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Contract.get('N_BALLOON')"
          class="col-span-2"
          [label]="'Residual'"
          [placeholder]="'Residual'"
        ></app-input-general>

        <app-input-general
          [formControlGeneral]="Contract.get('NUM_PLACA')"
          class="col-span-2"
          [label]="'Placa'"
          [placeholder]="'Placa'"
        ></app-input-general>
        <app-input-general-select
          [formControlGeneral]="Contract.get('EDO_PLACA')"
          [arrayData]="estadosSepomex"
          [inputSelect]="{ value: 'value', description: 'description' }"
          class="col-span-2"
          [label]="'Estado de placa'"
          [placeholder]="'Estado de placa'"
        ></app-input-general-select>

        <app-input-general
          [formControlGeneral]="Contract.get('NUM_PLACA_OLD')"
          class="col-span-2"
          [label]="'Placa antenor'"
          [placeholder]="'Placa antenor'"
        ></app-input-general>
        <app-input-general-select
          [formControlGeneral]="Contract.get('EDO_PLACA_OLD')"
          class="col-span-2"
          [arrayData]="estadosSepomex"
          [label]="'Estado de placa anterior'"
          [placeholder]="'Estado de placa anterior'"
          [inputSelect]="{ value: 'value', description: 'description' }"
        ></app-input-general-select>
      </div>
    </div>

    <div class="lg:px-8 px-0 pb-4 bg-white flex flex-col gap-4">
      <div
        class="px-4 py-2 text-general-subtitle text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      ></div>
      <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        <app-input-general
          [formControlGeneral]="Mastrack.get('AliasMastrack')"
          [label]="'Alias MASTRACK'"
          [placeholder]="'Alias MASTRACK'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('SerieMastrack')"
          [label]="'Serie MASTRACK'"
          [placeholder]="'Serie MASTRACK'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('ModeloMastrack')"
          [label]="'Modelo MASTRACK'"
          [placeholder]="'Modelo MASTRACK'"
        ></app-input-general>

        <app-input-general
          [formControlGeneral]="Mastrack.get('aP_PATERNO')"
          [label]="'Apellido Paterno'"
          [placeholder]="'Apellido Paterno'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('aP_MATERNO')"
          [label]="'Apellido Materno'"
          [placeholder]="'Apellido Materno'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('nombre')"
          [label]="'Nombre(s)'"
          [placeholder]="'Nombre(s)'"
        ></app-input-general>

        <app-input-general
          [formControlGeneral]="Mastrack.get('callE_NUM')"
          class="col-span-2"
          [label]="'Calle y Num.'"
          [placeholder]="'Calle y Num.'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('c_P')"
          [label]="'C.P'"
          [placeholder]="'C.P'"
          [mask]="'00000'"
          [allowNegativeNumbers]="false"
          [thousandSeparator]="''"
          [prefix]="''"
        ></app-input-general>

        <app-input-general-select
          [formControlGeneral]="Mastrack.get('colonia')"
          class="col-span-2"
          [label]="'Colonia'"
          [placeholder]="'Colonia'"
          [inputSelect]="{ value: 'value', description: 'description' }"
          [arrayData]="coloniesArray"
        ></app-input-general-select>

        <app-input-general
          [formControlGeneral]="Mastrack.get('delegacion')"
          class="col-span-2"
          [label]="'Delegación/Municipio'"
          [placeholder]="'Delegación/Municipio'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('ciudad')"
          class="col-span-2"
          [label]="'Ciudad'"
          [placeholder]="'Ciudad'"
        ></app-input-general>
        <div></div>

        <app-input-general-select
          [formControlGeneral]="Mastrack.get('estado')"
          [inputSelect]="{ value: 'value', description: 'description' }"
          class="col-span-"
          [label]="'Estado'"
          [placeholder]="'Estado'"
          [arrayData]="estadosSepomex"
        ></app-input-general-select>
        <div class="col-span-full"></div>

        <app-input-general
          [formControlGeneral]="Mastrack.get('tel')"
          class=""
          [label]="'Teléfono'"
          [mask]="'(000) 000-0000'"
          [placeholder]="'Teléfono'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('teL2')"
          class=""
          [label]="'Teléfono Celular'"
          [placeholder]="'Teléfono Celular'"
          [mask]="'(000) 000-0000'"
        ></app-input-general>
        <app-input-general
          [formControlGeneral]="Mastrack.get('email')"
          class=""
          [label]="'E-mail'"
          [placeholder]="'E-mail'"
        ></app-input-general>

        <div class="w-full flex justify-center items-center col-span-full">
          <button
            (click)="saveAllData()"
            class="button-general text-center !w-auto h-12.75 mt-2"
            matButton="filled"
          >
            ACTUALIZAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>